import { ElMessage } from 'element-plus'
import { defineStore } from 'pinia'
import { getCurrentUserInfoApi, isSystemAdminApi } from '@/apis/login'

export const useUserStore = defineStore('user', () => {
	// 个人信息
	const userInfo = ref<NKmUser.UserInfo>()

	// 获取个人信息
	const getUserInfo = () => {
		return new Promise(async (resolve, reject) => {
			try {
				const { data } = await getCurrentUserInfoApi()
				userInfo.value = data
				userInfo.value.isAdminPage = false
				resolve(data)
			} catch (error) {
				reject(error)
			}
		})
	}
	// 获取是否系统管理员
	const isSystemAdmin = () => {
		if (userInfo.value) {
			userInfo.value.systemAdmin = false
		}
		return new Promise(async (resolve, reject) => {
			try {
				const res = await isSystemAdminApi()
				if (res.code === 200 && userInfo.value) {
					userInfo.value.systemAdmin = res.data as boolean
				}
				resolve(res.data)
			} catch (error) {
				reject(error)
			}
		})
	}

	return {
		userInfo,
		getUserInfo,
		isSystemAdmin
	}
})
